<template>
  <div class="wrap">
    <navBar title="去赚钱" :left-show="false"></navBar>
    <div class="emptyNaBar"></div>

    <div class="content">
      <!-- ====== 安卓用户提示 ====== -->
      <div class="card android-card" v-if="platform === 'android'">
        您是安卓用户，您可以在手机应用商店搜索"我惠省钱"下载安装App。在App内可以看到更丰富的"去赚钱"页面。
      </div>

      <!-- ====== 我的小店 ====== -->
      <div class="card">
        <div class="card-header">
          <span class="card-title">我的小店</span>
          <div class="spacer"></div>
          <span class="card-hint"
                @click="openWebView('我的小店', 'https://m.whsq365.com/wohuisq/display/agreement?id=7')">小店解析?</span>
          <button class="btn-action btn-primary" @click="onCFMHome">我的小店</button>
        </div>
      </div>

      <!-- ====== 我抢代理 ====== -->
      <div class="card">
        <div class="card-header">
          <span class="card-title">我抢代理</span>
          <div class="spacer"></div>
        </div>

        <div class="agent-row">
          <span class="agent-label flex-1">你有抢县区单品代理资格</span>
          <span class="card-hint"
                @click="openWebView('单品代理', 'https://m.whsq365.com/wohuisq/display/agreement?id=10')">代理解析?</span>
          <button class="btn-action btn-info" @click="openPCA">抢代理</button>
          <button class="btn-action btn-primary" @click="onPCAHome">我的专卖</button>
        </div>

        <div class="agent-row">
          <span class="agent-label flex-1">你有抢全国厂家总店资格</span>
          <span class="card-hint"
                @click="openWebView('全国厂家总店', 'https://m.whsq365.com/wohuisq/display/agreement?id=35')">总店解析?</span>
          <button class="btn-action btn-info" @click="openNFH">抢总店</button>
          <button class="btn-action btn-primary" @click="onNFHHome">我的总店</button>
        </div>
      </div>

      <!-- ====== 我抢爆品 ====== -->
      <div class="card">
        <div class="card-header">
          <span class="card-title">我抢爆品</span>
          <div class="spacer"></div>
          <span class="card-hint"
                @click="openWebView('抢爆品', 'https://m.whsq365.com/wohuisq/display/agreement?id=18')">爆品解析?</span>
          <button class="btn-action btn-primary" @click="goBaoPin">抢爆品</button>
        </div>
      </div>

      <!-- ====== 我领赠品 ====== -->
      <div class="card">
        <div class="card-header">
          <span class="card-title">我领赠品</span>
          <div class="spacer"></div>
        </div>
        <div class="agent-row">
          <span class="agent-label flex-1">
            您有
            <span class="highlight-num">{{ taskInit.GStock || '0' }}</span>
            盒赠品待领取
          </span>
          <span class="card-hint"
                @click="openWebView('领赠品', 'https://m.whsq365.com/wohuisq/display/agreement?id=19')">赠品解析?</span>
          <button class="btn-action btn-primary" @click="goLingGift">领赠品</button>
        </div>
      </div>
    </div>

    <!-- 底部菜单 -->
    <foot-bar :active="2"></foot-bar>
  </div>
</template>

<script>
import { ForTaskInit } from "../../../api/commonV2";

export default {
  name: 'task',
  data() {
    return {
      uid: '',
      taskInit: {},
      platform: ''
    }
  },
  created() {
    this.detectPlatform()
    this.uid = localStorage.getItem("uid") || ''
    if (!this.uid) {
      this.$router.push('/user/login')
      return
    }
    this.getTaskInit()
  },
  methods: {
    /* ==================== 平台检测 ==================== */
    detectPlatform() {
      const ua = (navigator.userAgent || '').toLowerCase()
      if (ua.indexOf('android') > -1) {
        this.platform = 'android'
      } else if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
        this.platform = 'ios'
      }
    },

    /* ==================== 加载页面数据 ==================== */
    getTaskInit() {
      const data = { uid: this.uid }
      ForTaskInit(data)
        .then(res => {
          if (res.result === '0') {
            this.taskInit = res
          } else {
            this.$toast && this.$toast(res.resultNote || '加载失败')
          }
        })
        .catch(() => {
          this.$toast && this.$toast('加载失败，请重试')
        })
    },

    /* ==================== 我的小店 ==================== */
    onCFMHome() {
      if (Number(this.taskInit.IsCFM) === 1) {
        this.$router.push('/me/cfm/index')
      } else {
        this.$dialog.alert({
          title: '温馨提示',
          message: '您还没有开通小店，完成打卡即可成功开通小店！',
          confirmButtonText: '知道了',
          confirmButtonColor: this.m_color
        })
      }
    },

    /* ==================== 开通单品代理 ==================== */
    openPCA() {
      const feeId = this.taskInit.PCAZSQFeeID
      if (feeId) {
        this.$router.push('/whyd/ydDetail?ydId=' + feeId)
      } else {
        this.$router.push('/common/search?active=0&keyword=单品代理')
      }
    },

    /* ==================== 我的专卖 ==================== */
    onPCAHome() {
      if (Number(this.taskInit.IsPCA) === 1) {
        this.$router.push('/me/pca/index')
      } else {
        this.$dialog.confirm({
          title: '温馨提示',
          message: '您还没有开通我的专卖，是否现在去抢代理？',
          confirmButtonText: '立即抢代理',
          cancelButtonText: '再想想',
          confirmButtonColor: this.m_color
        }).then(() => {
          this.openPCA()
        }).catch(() => {
          // 取消，不处理
        })
      }
    },

    /* ==================== 开通全国厂家总店 ==================== */
    openNFH() {
      const feeId = this.taskInit.NFHFeeID
      if (feeId) {
        this.$router.push('/whyd/ydDetail?ydId=' + feeId)
      } else {
        this.$router.push('/common/search?active=0&keyword=全国厂家总店')
      }
    },

    /* ==================== 我的总店 ==================== */
    onNFHHome() {
      if (Number(this.taskInit.IsNFH) === 1) {
        this.$router.push('/me/nfh/index')
      } else {
        this.$dialog.confirm({
          title: '温馨提示',
          message: '您还没有开通全国厂家总店，是否现在去抢总店？',
          confirmButtonText: '立即抢总店',
          cancelButtonText: '再想想',
          confirmButtonColor: this.m_color
        }).then(() => {
          this.openNFH()
        }).catch(() => {
          // 取消，不处理
        })
      }
    },

    /* ==================== 抢爆品 ==================== */
    goBaoPin() {
      this.$router.push('/whyd/ydZone?zoneType=3&zoneName=' + encodeURIComponent('爆品专区'))
    },

    /* ==================== 领赠品 ==================== */
    goLingGift() {
      this.$router.push('/me/wohui/gift/get')
    },

    /* ==================== 打开规则页 ==================== */
    openWebView(title, url) {
      this.$router.push('/common/rule?title=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(url))
    }
  }
}
</script>

<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: #f2f2f7;
}

.content {
  padding: 12px;
}

/* ====== 卡片 ====== */
.card {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}

.android-card {
  background: #E61B1B;
  color: #fff;
  font-size: 13px;
  line-height: 1.6;
}

.card-header {
  display: flex;
  align-items: center;
}

.card-title {
  font-size: 15px;
  color: #1a1a1a;
  font-weight: bold;
}

.card-hint {
  font-size: 11px;
  color: #4a90d9;
  margin-left: 8px;
  margin-right: 4px;
  cursor: pointer;
}

.spacer {
  flex: 1;
}

.flex-1 {
  flex: 1;
}

/* ====== 代理 / 赠品行 ====== */
.agent-row {
  display: flex;
  align-items: center;
  margin-top: 12px;

  &:first-of-type {
    margin-top: 0;
  }
}

.agent-label {
  font-size: 13px;
  color: #666;
  text-align: left !important;
}

.highlight-num {
  color: #e61b1b;
  font-weight: bold;
}

/* ====== 按钮 ====== */
.btn-action {
  flex-shrink: 0;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  border-radius: 16px;
  padding: 0 16px;
  margin: 0 0 0 8px;
  border: none;
  cursor: pointer;
  outline: none;

  &:active {
    opacity: 0.85;
  }
}

.btn-primary {
  background: linear-gradient(135deg, #e61b1b 0%, #ff4757 100%);
}

.btn-info {
  background: linear-gradient(135deg, #4a90d9 0%, #5ba0e6 100%);
}
</style>



// WEBPACK FOOTER //
// src/view/tabBar/task/index.vue